import Image from 'next/image'
import { getBrand } from '@/lib/brands'

/**
 * Logo de las cabeceras públicas (`LandingNav`, `LegalNav`): ficha blanca
 * redondeada con el icono de la marca. `rounded-md` en la imagen porque los
 * iconos de marca son cuadrados opacos a sangre (sirven de icono maskable de la
 * PWA) y sin recorte quedaban como un cuadrado sobre la ficha redondeada. El
 * área logueada usa `AppShellLogo` (sin ficha, `rounded-xl`).
 */
export function BrandNavLogo() {
  const brand = getBrand()
  return (
    <div className="rounded-lg bg-white p-1">
      <Image src={brand.assets.logo} alt={brand.name} width={40} height={40} className="h-6 w-6 rounded-md md:h-8 md:w-8" />
    </div>
  )
}
